import script from "./DynamicAppTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTextElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppTextElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppTextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "210e8cbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('210e8cbc', __exports__)) {
    api.reload('210e8cbc', __exports__)
  }
  
}


export default __exports__